import React, { Component } from "react";
import Dropzone from "react-dropzone";
import Delete from "@material-ui/icons/Delete";
import { deleteAttachments } from "../../services/attachments";
import "./fileUploader.css";
import { IconButton } from "@material-ui/core";
export const apiUrl = process.env.REACT_APP_API_URL;
console.log(apiUrl);
class ReusableDropzone extends Component {
  onDrop = (newFiles) => {
    const oldAttachments = this.props.state.attachments || [];

    this.props.setState((prevState) => ({
      attachments: [...oldAttachments, ...prevState.attachments, ...newFiles],
    }));
  };
  deleteFile = async (index) => {
    this.props.setState((prevState) => {
      const updatedFiles = [...prevState.attachments];
      updatedFiles.splice(index, 1);
      return { attachments: updatedFiles };
    });
  };

  deleteSavedAttachments = async (item, id, type) => {
    try {
      console.log(id);
      const resp = await deleteAttachments(item.filePath, id, type);
      console.log(resp);
      await this.props.populate();
    } catch (error) {
      console.log(error);
    }
  };
  render() {
    const { attachments } = this.props.state;
    console.log(attachments);
    console.log("these are attachments");
    console.log(this.props.type);
    console.log(attachments);
    const files = attachments.map((file, index) => (
      <li key={file.name}>
        {file.filePath ? (
          <div className="file_uploader_card">
            <div className="">
              <img
                src={`${apiUrl}/${file.filePath}`}
                alt={file.fileName || file.name}
                className="file_uploader_card_image"
              />
            </div>
            <div>
              <IconButton
                className=""
                onClick={() => {
                  this.deleteSavedAttachments(
                    file,
                    this.props.id,
                    this.props.type
                  );
                  this.deleteFile(file.id);
                }}
              >
                <Delete className="delete_icon_file_uploader_button" />
              </IconButton>
            </div>
          </div>
        ) : (
          <div className="file_uploader_card">
            <div className="">
              <img
                src={URL.createObjectURL(file)}
                alt={file.fileName || file.name}
                className="file_uploader_card_image"
              />
            </div>
            <div>
              <IconButton className="" onClick={() => this.deleteFile(index)}>
                <Delete className="delete_icon_file_uploader_button" />
              </IconButton>
            </div>
          </div>
        )}
      </li>
    ));

    return (
      <Dropzone onDrop={this.onDrop}>
        {({ getRootProps, getInputProps }) => (
          <section className="container">
            <div {...getRootProps({ className: "dropzone" })}>
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <aside>
              <h4>Files</h4>
              <ul className="file_uploader_react">{files}</ul>
            </aside>
          </section>
        )}
      </Dropzone>
    );
  }
}

export default ReusableDropzone;
